import { keys } from '../../../00-base/global/utils/keycodes';
import getFocusable from '../../../00-base/global/utils/get-focusable';

function initSocialComments(context) {
    if (typeof context === "undefined") {
        context = document;
    }

    [...context.querySelectorAll('.social-comments')].forEach(el => {
        const toggle = el.querySelector('.js-social-comments-expand');
        const shelf = el.querySelector('.js-social-comments-shelf');

        if (!shelf) {
            return;
        }
        const close = el.querySelector('.js-social-comments-shelf-close');
        const shelfTabbables = shelf ? [...shelf.querySelectorAll('a, button'), shelf] : [];
        const bodyTabbables = getFocusable(document, false).filter(el => {
                return !shelf.contains(el);
            });

        /**
         * Esc keydown handler.
         */
        function escHandler(e) {
            if (e.keyCode === keys.esc) {
                handleShelf(false, true);
            }
        }

        /**
         * Click outside shelf handler.
         */
        function clickOutsideShelfHandler(e) {
            if (!(e.target === shelf || shelf.contains(e.target))) {
                handleShelf(false, false);
            }
        }

        /**
         * Open/close shelf.
         *
         * @param open boolean Whether to open (true) or close (false)
         */
        function handleShelf(open, needsSetFocus) {
            const setTabIndex = function(el, shouldBeTabbable) {
                if (shouldBeTabbable) {
                    el.removeAttribute('tabindex');
                } else {
                    el.setAttribute('tabindex', -1);
                }
            };

            // Make shelf links tabbable or not.
            shelfTabbables.forEach(el => {
                setTabIndex(el, open);
            });

            bodyTabbables.forEach(el => {
                setTabIndex(el, !open);
            });


            // Set toggle attributes.
            toggle.setAttribute('aria-expanded', open);

            let toFocus = null;
            if (open) {
                // Open shelf.
                shelf.classList.add('open');
                shelf.setAttribute('aria-hidden', 'false');

                // Add Esc key & click outside shelf handler.
                document.addEventListener('keydown', escHandler);
                document.addEventListener('click', clickOutsideShelfHandler);

                // Disable body scroll.
                document.body.classList.add('no-scroll');

                //focus first control in shelf so that tab focus does not disappear
                toFocus = document.querySelector('.js-social-comments-shelf-close');
            }
            else {
                // Close shelf.
                shelf.classList.remove('open');
                shelf.setAttribute('aria-hidden', 'true');

                // Remove Esc key & click outside shelf handler.
                document.removeEventListener('keydown', escHandler);
                document.removeEventListener('click', clickOutsideShelfHandler);

                // Enable body scroll.
                document.body.classList.remove('no-scroll');

                toFocus = document.querySelector('.js-social-comments-expand');
            }

            if (toFocus && needsSetFocus) {
                toFocus.focus();
            }

        }

        // Call shelf handler on toggle/close click and shelf blur.
        if (toggle && shelf && close) {
            toggle.addEventListener('click', e => {
                e.stopImmediatePropagation();
                handleShelf(true, true);
            });

            close.addEventListener('click', e => {
                handleShelf(false, true);
            });

            shelf.addEventListener('blur', e => {
                if (e.target) {
                    const target_shelf = e.target.closest('.js-social-comments-shelf');
                    if (target_shelf.getAttribute('aria-hidden') == 'false') {
                        handleShelf(false, false);
                    }
                }
            });
        }
    });
}

export default initSocialComments;
